import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Paper, TablePagination } from '@material-ui/core';
import MaterialTable from 'material-table';
import { rounded } from '../../../utils.js'
import ALRSpecPopup  from './ALRSpecPopup.js';
import { Dialog, Icon, Button } from '@blueprintjs/core';
import { CsvBuilder } from "filefy";
import '../results.css';
//import {estimatedClass} from '../common'
import { prepDangerouslySetInnerHTMLString } from './../concord/utils';


class ALRTab extends React.PureComponent {

  constructor(props) {
    super(props);

    const tableRows = this.props.alrOcc.map(row => this.prepTableRow(row));
    
    this.state = { 
      isOpenModal:false,
      tableRows,
      currentKey:0, // the current key for the coocSpec chart
      query2real:this.calcQuery2real(this.props.alrOcc)
    };
  }

  ALRSpecPopup = (e) => {
    this.setState({currentKey:e.target.value});
    this.toggleModal();
  };
  toggleModal = () => {
    this.setState(prevState => ({ isOpenModal: !prevState.isOpenModal }));
  }

  // construction of the correspondence between ALR query and realization
  calcQuery2real = (alrOcc) => {
    var query2real={};
    for (var numRow in alrOcc) {
      const row=alrOcc[numRow];
      query2real[row[2]]=row[3]
    }
    return query2real;
  }
  formatQuery = (q) => {
    return q.replace(/\|/g,"| ");

  }

  prepTableRow = (row) => {
    // for subCorpus tab :
    // [$firstLevelColloc,$size,$realizedNode,$surfaceRealization,$example,round($f),round($t),round($F),$T,round($disp),round($am{'am.log.likelihood'})]);
    if (this.props.displaySpec) {
      return {
        'firstLevelColloc': row[0],
        'size': row[1],
        'query': row[2],
        'realization': row[3],
        'example': <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(row[4])} />,
        'rawExample':row[4],
        'alrOccNum': rounded(row[5]),
        'disp': row[9],
        'spec': row[10],
        'compare': <button value={row[2]} onClick={this.ALRSpecPopup}>cmp</button>,
      };
    // for global tab, no spec values
    // $firstLevelColloc,$size,$realizedNode,$surfaceRealization,$example,round($F),$T,round($disp)]);
    } else {
      return {
        'firstLevelColloc': row[0],
        'size': row[1],
        'query': row[2],
        'realization': row[3],
        'example': <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(row[4])} />,
        'rawExample':row[4],
        'alrOccNum': rounded(row[5]),        
        'disp': row[7],
        'compare': <button value={row[2]} onClick={this.ALRSpecPopup}>cmp</button>,
      };
 
    }
  }

  
  render() {
    const { t, displaySpec } = this.props;
    const { isOpenModal} = this.state;

    let columnDefinition;

    if (displaySpec) {
      columnDefinition=[
        { title: t('firstLevelColloc'), field: 'firstLevelColloc' },
        { title: t('size'), field: 'size' },
        { title: t('query'), 
          field: 'query', 
          render: rowData => <Button minimal small onClick={()=> { this.props.performSearch({query:rowData.query})} } >{this.formatQuery(rowData.query)}</Button> },
        { title: t('realization'), field: 'realization' },
        { title: t('example'), field: 'example', cellStyle: { width: '30%' }},
        { title: t('alrOccNum'), field: 'alrOccNum' },
//        { title: t('alrOccNum'), field: 'numPivotOcc', render: rowData => <span className={estimatedClass(rowData.alrOccNum,this.props.estimatedResults)}>{rounded(rowData.alrOccNum)}</span> },
        { title: t('dispersion'), field: 'disp' },
        { title: t('spec'), field: 'spec' },
        { title: t('compare'), field: 'compare' },
        { title: t('generalize'), 
          field: 'query', 
          render: rowData => <Button minimal small onClick={()=> { this.props.performSearch({query:rowData.query,generalize:true})} } ><Icon icon="send-to-graph" iconSize={18} /></Button> },
      ];
    } else {
      // for global tab, no spec
      columnDefinition=[
        { title: t('firstLevelColloc'), field: 'firstLevelColloc' },
        { title: t('size'), field: 'size' },
        { title: t('query'), 
          field: 'query', 
          render: rowData => <Button minimal small onClick={()=> { this.props.performSearch({query:rowData.query})} } >{this.formatQuery(rowData.query)}</Button> },
        { title: t('realization'), field: 'realization' },
        { title: t('example'), field: 'example', cellStyle: { width: '30%' }},
        { title: t('alrOccNum'), field: 'alrOccNum' },
//        { title: t('alrOccNum'), field: 'numPivotOcc', render: rowData => <span className={estimatedClass(rowData.alrOccNum,this.props.estimatedResults)}>{rounded(rowData.alrOccNum)}</span> },
        { title: t('dispersion'), field: 'disp' },
        { title: t('compare'), field: 'compare' },
        { title: t('generalize'), 
          field: 'query', 
          render: rowData => <Button minimal small onClick={()=> { this.props.performSearch({query:rowData.query,generalize:true})} } ><Icon icon="send-to-graph" iconSize={18} /></Button> },
      ];
    }

   
    return (
      <>
        <div className="margin-top-2-rem">
          <MaterialTable
            title={t('alr')}
            columns={columnDefinition}
            data={this.state.tableRows}
            options={{
              filtering: true,
              search: true,
              sorting: true,
              exportButton: true,
              exportFile: 'alr',
              exportAlldata: true,
              rowStyle: {
                height:'70px',
              },
              padding: 'dense',
              exportCsv: (columns, data) => {
                const fileName = "ALR_table";
                const builder = new CsvBuilder(
                    fileName + ".csv"
                );
                builder
                    .setColumns(
                        ["first colloc","size","query","realization","example","frequency","dispersion","specificity"]
                    )
                    .addRows(
                      data.map((rowData) =>
                          [
                            rowData.firstLevelColloc,
                            rowData.size,
                            rowData.query,
                            rowData.realization,
                            rowData.rawExample,
                            rowData.alrOccNum,
                            rowData.disp,
                            rowData.spec,
                          ]
                        )
                    )
                    .exportFile();
              },
            }}
            components={{
              Pagination: props => (
                <TablePagination
                  {...props}
                  rowsPerPageOptions={[5, 10, 25, 50, 100, this.state.tableRows.length ]}
                />
              ),
              Container: props => (
                <Paper
                  {...props}
                  elevation={0}
                />
              ),
            }}
          />
        </div>

        <Dialog
            isOpen={isOpenModal}
            onClose={this.toggleModal}
            title={t('alrSpecComparisonBtn')}
            style={{'width': '800px'}}  // 800px seems a good deal
        >
          <ALRSpecPopup realization={this.state.query2real[this.state['currentKey']]} alr={this.state['currentKey']} data={this.props.alrSpec[this.state['currentKey']]}/>
        </Dialog>
      </>
    ); 
  }
}

ALRTab.propTypes = {
  // see prepCoocData for an example
  alrOcc: PropTypes.array,
  alrSpec: PropTypes.object,
  displaySpec: PropTypes.bool,
  performSearch: PropTypes.func,  
};

export default withTranslation()(ALRTab);
